import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../lib/LanguageContext';
export function FundingPathways() {
  const {
    t,
    tArray
  } = useLanguage();
  const regions = [{
    name: 'Canada',
    accent: '🍁'
  }, {
    name: 'USA',
    accent: '🦅'
  }, {
    name: 'Mexico',
    accent: '🌵'
  }, {
    name: 'International',
    accent: '🌍'
  }];
  const opportunities = tArray<string>('fundingPathways.opportunities');
  return <section className="py-24 md:py-32 bg-sandstone relative" id="support" data-id="element-64" data-mp="7o6joeq9w40r">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-65" data-mp="lf1n3bi05swy">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-66" data-mp="lgmh900en9ua">
          <h2 className="text-3xl md:text-5xl font-heading text-navy mb-4" data-id="element-67" data-mp="7whl2fcpxbwn">
            {t('fundingPathways.title')}
          </h2>
          <p className="text-navy/70 text-lg" data-id="element-68" data-mp="ctr7rn8q39gs">
            {t('fundingPathways.subtitle')}
          </p>
        </motion.div>

        {/* Regional Donations */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-69" data-mp="mklx50h9mp6g">
          {regions.map((region, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-ivory p-8 rounded-sm border border-gold/20 text-center flex flex-col justify-between h-full hover:shadow-lg hover:border-saffron/50 transition-all" data-id="element-70" data-mp="3l5nazx35qnlv" data-mpi={idx}>
              <div data-id="element-71" data-mp="3bfjy5opxisop">
                <div className="text-2xl mb-4 opacity-80" data-id="element-72" data-mp="36f5raa02dos9">{region.accent}</div>
                <h3 className="font-heading text-xl text-navy mb-2" data-id="element-73" data-mp="3kef6p7gg4ev6">
                  {t('fundingPathways.donateFrom')} {region.name}
                </h3>
              </div>
              <button className="mt-6 w-full py-3 border border-navy/20 text-navy/50 rounded-sm text-xs tracking-widest uppercase font-medium cursor-not-allowed" data-id="element-74" data-mp="3fg3uiq2ohs9s">
                {t('fundingPathways.comingSoon')}
              </button>
            </motion.div>)}
        </div>

        {/* Other Opportunities */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="bg-navy text-ivory p-8 md:p-12 rounded-sm border border-gold/30" data-id="element-75" data-mp="2wot92ofq27pa">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left divide-y md:divide-y-0 md:divide-x divide-gold/20" data-id="element-76" data-mp="o9d23ecalaq9">
            <div className="space-y-6" data-id="element-77" data-mp="aizvpgf1u431">
              {opportunities.map((opp, idx) => <div key={idx} className="flex flex-col sm:flex-row sm:items-center justify-between p-4 rounded-sm bg-navy/20 border border-warmWhite/5 hover:border-saffron/30 transition-colors" data-id="element-78" data-mp="fhb0hcqhloee" data-mpi={idx}>
                  <h4 className="text-warmWhite font-medium mb-2 sm:mb-0" data-id="element-79" data-mp="t7wm397bscfz">
                    {opp}
                  </h4>
                  <a href="https://wa.me/6596670750" target="_blank" rel="noopener noreferrer" className="text-saffron text-sm tracking-widest uppercase font-medium hover:text-warmWhite transition-colors flex items-center group" data-id="element-80" data-mp="y67x3n9cwszs">
                    {t('fundingPathways.inquireCta')}
                    <span className="ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-81" data-mp="3tgevftuf23f0">
                      →
                    </span>
                  </a>
                </div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}